module.exports = __webpack_public_path__ + "img/exchange3.429d69d9.jpg";